import React from 'react'
import PropTypes from 'prop-types'

export default class LanguageBlock extends React.Component {
    static get propTypes () {
        return {
            children : PropTypes.array.isRequired 
        }
    } 
    render () {
        return (
            <div className="query-description">
                {this.props.children}
            </div>
        )
    }
}
